import styled from "styled-components";
import React, { useEffect } from "react";
import Checkbox from "../../Common/Components/Checkbox";
import { changeHandlerAction } from "../action";
import store, { RootState } from "store";
import { useSelector } from "react-redux";

interface ICheckBoxTextOnRight {
  objectKey: string;
  id: number;
  description?: string;
  checked: boolean;
  isOptions: boolean;
}

const CheckBoxTextOnRight: React.FC<ICheckBoxTextOnRight> = (props: ICheckBoxTextOnRight) => {
  const { objectKey, id, checked, description, isOptions } = props;
  let isUnSubAllChecked = useSelector((state: RootState) => state.preferenceManagement.unsub_all);

  let preferenceManagementState = useSelector((state: RootState) => state.preferenceManagement);
  const newsLetters = useSelector((state: RootState) => state.preferenceManagement.news_letters);
  const alerts = useSelector((state: RootState) => state.preferenceManagement.alerts);

  let newsLetterIndex = 0;
  let alertsIndex = 0;
  let index = 0;

  if (isOptions) {
    newsLetterIndex = newsLetters?.findIndex((nl: any) => nl.id === id) ?? -1;
    alertsIndex = alerts?.findIndex((al: any) => al.name === description) ?? -1;
    index = objectKey === "alerts" ? alertsIndex : newsLetterIndex;
  }

  const handleOnChange = (key: string, value: boolean, id?: number) => {
    changeHandlerAction(key, value ? "1" : "0", id);
  };
  return (
    <>
      <Wrapper>
        <Checkbox
          disabled={isUnSubAllChecked === "1"} //! check it again
          checked={isOptions ? preferenceManagementState[objectKey][index].status === "1" : checked}
          onChange={(e: any) => handleOnChange(objectKey, e.target.checked, id)}
        />
        <p className="component-description">{description}</p>
      </Wrapper>
    </>
  );
};

export default CheckBoxTextOnRight;

const Wrapper = styled.div`
  flex-grow: 1;
  flex-basis: 50%;
  padding-bottom: 25px;
  &:last-child {
    padding-bottom: 0;
  }
  .component-description {
    margin-left: 24px;
    font-family: "Roboto";
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    letter-spacing: -0.555556px;
    color: #5e7079;
    padding-top: 1px;
    margin-bottom: 0;
  }
`;
